// Mirrors `file_size_limit` in Query's upload route (data_query/versions/v1/routes/upload.py).
// Query switches to multipart at this exact byte count, not 40 MiB, and the ETag verification
// only matches when both sides pick the same method for the same file.
export const MULTIPART_UPLOAD_THRESHOLD_BYTES = 40000000;

export const isMultipartUpload = (fileSize) => fileSize >= MULTIPART_UPLOAD_THRESHOLD_BYTES;
